import { Component, OnInit } from '@angular/core';
import { SettingService } from '../services/setting.service';
import { TransactionService } from '../services/transactions.service';
import { Transaction } from '../models/transaction';
import { VoucherDetails } from '../models/voucherDetails';
import { OfferService } from '../services/offer.service';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})
export class TransactionsComponent implements OnInit {

  constructor(
    public settingService: SettingService,
    public transactionService: TransactionService,
    public offerService: OfferService,
  ) { }
  allTransactions: Transaction[] = [];
  pageTransactions:Transaction[] = [];
  allOffers: VoucherDetails[] = [];
  pageOffers:VoucherDetails[] = [];
  totalItems=0;
  currentpage = 1;
  pageSize=20;
  previousPage: any;
  transactionFlag=true;
  active = 1;
  ngOnInit() {
    this.settingService.pageName='transactions';
   this.getAllTransactions();
   this.reload();
  }
  loadPage(page: number) {
    if (page !== this.currentpage) {
      this.currentpage = page;
      
      this.getPage();
    }
  }
  
  getAllTransactions() {
    this.settingService.loading = true;
    this.transactionFlag=true;
    this.currentpage=1;
    this.totalItems=0;
    this.transactionService.getAllTransactions().subscribe(res => {
       this.allTransactions = res;
       this.totalItems = res.length;
       this.pageTransactions = this.allTransactions.slice(0, this.pageSize);
       this.getPage();
      this.settingService.loading = false;
    });
  }
  getPage() {
    if(this.transactionFlag==true)
    {
      this.pageTransactions = this.allTransactions.slice(this.pageSize*(this.currentpage-1), this.pageSize*this.currentpage);
    }
    else 
    {
      this.pageOffers = this.allOffers.slice(this.pageSize*(this.currentpage-1), this.pageSize*this.currentpage);
    }

  }
  getAllOffers() {
    this.settingService.loading = true;
    this.transactionFlag=false;
    this.currentpage=1;
    this.totalItems=0;
    this.offerService.getAllOffers().subscribe(res => {
       this.allOffers = res;
       this.totalItems = res.length;
       this.pageOffers = this.allOffers.slice(0, this.pageSize);
       this.getPage();
      this.settingService.loading = false;
    });
  }
  reload() {
    this.settingService.languageEvent.subscribe(res => {
      if(this.transactionFlag==true)
    {
      this.getAllTransactions();

    }
    else
    {
       this.getAllOffers();
    }
    });
  }
}
